<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter101enmityoffacesmacking">CHAPTER 101 - ENMITY OF FACE-SMACKING</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter102siblingfighting">CHAPTER 102 - SIBLING FIGHTING</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter103inequalityofroad">CHAPTER 103 - INEQUALITY OF ROAD</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter104lightning">CHAPTER 104 - LIGHTNING</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter105leixiu">CHAPTER 105 - LEI XIU</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter106endofaudition">CHAPTER 106 - END OF AUDITION</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter107snowflake">CHAPTER 107 - SNOWFLAKE</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter108thebattleofthedemons">CHAPTER 108 - THE BATTLE OF THE DEMONS</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter109qilindemonsoldiers" title="Link target outside of Sample">CHAPTER 109 - QILIN DEMON SOLDIERS</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter110winning" title="Link target outside of Sample">CHAPTER 110 - WINNING</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter111resentment" title="Link target outside of Sample">CHAPTER 111 - RESENTMENT</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter112goldenmarionette" title="Link target outside of Sample">CHAPTER 112 - GOLDEN MARIONETTE</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter113demonarmyattack" title="Link target outside of Sample">CHAPTER 113 - DEMON ARMY ATTACK</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter114demonichorde" title="Link target outside of Sample">CHAPTER 114 - DEMONIC HORDE</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter115fightingdemonsoldiersheadon" title="Link target outside of Sample">CHAPTER 115 - FIGHTING DEMON SOLDIERS HEAD ON</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter116endofpreliminarycompetition" title="Link target outside of Sample">CHAPTER 116 - END OF PRELIMINARY COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter117fructusartemisiae" title="Link target outside of Sample">CHAPTER 117 - FRUCTUS ARTEMISIAE</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter118arrogantlackeys" title="Link target outside of Sample">CHAPTER 118 - ARROGANT LACKEYS</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter119strength" title="Link target outside of Sample">CHAPTER 119 - STRENGTH</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter120thedifficultiesofflatten" title="Link target outside of Sample">CHAPTER 120 - THE DIFFICULTIES OF FLATTEN</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter121sundawei" title="Link target outside of Sample">CHAPTER 121 - SUN DAWEI</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter122suspect" title="Link target outside of Sample">CHAPTER 122 - SUSPECT</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter123dinner" title="Link target outside of Sample">CHAPTER 123 - DINNER</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter124innercourtman" title="Link target outside of Sample">CHAPTER 124 - INNER COURT MAN</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter125defeat" title="Link target outside of Sample">CHAPTER 125 - DEFEAT</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter126humansacrificeceremony" title="Link target outside of Sample">CHAPTER 126 - HUMAN SACRIFICE CEREMONY</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter127decline" title="Link target outside of Sample">CHAPTER 127 - DECLINE</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter128ontheeveofthesacrificeceremony" title="Link target outside of Sample">CHAPTER 128 - ON THE EVE OF THE SACRIFICE CEREMONY</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter129ceremonyofthesacrificeofthehumanrace" title="Link target outside of Sample">CHAPTER 129 - CEREMONY OF THE SACRIFICE OF THE HUMAN RACE</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter130attheceremonyofhumansacrifice" title="Link target outside of Sample">CHAPTER 130 - AT THE CEREMONY OF HUMAN SACRIFICE</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter131fantasyplains" title="Link target outside of Sample">CHAPTER 131 - FANTASY PLAINS</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter132departure" title="Link target outside of Sample">CHAPTER 132 - DEPARTURE</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter133departureinprogress" title="Link target outside of Sample">CHAPTER 133 - DEPARTURE IN PROGRESS</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter134departure" title="Link target outside of Sample">CHAPTER 134 - DEPARTURE</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter135gambler" title="Link target outside of Sample">CHAPTER 135 - GAMBLER</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter136leave" title="Link target outside of Sample">CHAPTER 136 - LEAVE</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter137menstears" title="Link target outside of Sample">CHAPTER 137 - MEN'S TEARS</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter138cooperation" title="Link target outside of Sample">CHAPTER 138 - COOPERATION</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter139task" title="Link target outside of Sample">CHAPTER 139 - TASK</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter140escortcaravan" title="Link target outside of Sample">CHAPTER 140 - ESCORT CARAVAN</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter141avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 141 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter142avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 142 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter143avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 143 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter144avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 144 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter145avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 145 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter146avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 146 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter147avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 147 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter148avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 148 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter149tourofthewicked9" title="Link target outside of Sample">CHAPTER 149 - TOUR OF THE WICKED 9</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter150acityofthewickedten" title="Link target outside of Sample">CHAPTER 150 - A CITY OF THE WICKED TEN</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter151avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 151 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter152acityofthewickedtwelve" title="Link target outside of Sample">CHAPTER 152 - A CITY OF THE WICKED TWELVE</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter153avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 153 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter154avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 154 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter155avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 155 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter156avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 156 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter157avisittothecityofthewicked" title="Link target outside of Sample">CHAPTER 157 - A VISIT TO THE CITY OF THE WICKED</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter158gangsterontheroad" title="Link target outside of Sample">CHAPTER 158 - GANGSTER ON THE ROAD</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter159fortunetelling" title="Link target outside of Sample">CHAPTER 159 - FORTUNE-TELLING</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter160tentativewindandrain" title="Link target outside of Sample">CHAPTER 160 - TENTATIVE WIND AND RAIN</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter161heteromorphism" title="Link target outside of Sample">CHAPTER 161 - HETEROMORPHISM</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter162bloodcontinent" title="Link target outside of Sample">CHAPTER 162 - BLOOD CONTINENT</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter163seventhyoungmaster" title="Link target outside of Sample">CHAPTER 163 - SEVENTH YOUNG MASTER</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter164wintheheartsandmindsofthepeople" title="Link target outside of Sample">CHAPTER 164 - WIN THE HEARTS AND MINDS OF THE PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter165planning" title="Link target outside of Sample">CHAPTER 165 - PLANNING</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter166uplift" title="Link target outside of Sample">CHAPTER 166 - UPLIFT</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter167businessplan" title="Link target outside of Sample">CHAPTER 167 - BUSINESS PLAN</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter168taskchange" title="Link target outside of Sample">CHAPTER 168 - TASK CHANGE</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter169breakthroughmidfoundationestablishment" title="Link target outside of Sample">CHAPTER 169 - BREAK THROUGH MID FOUNDATION ESTABLISHMENT</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter170majorreward" title="Link target outside of Sample">CHAPTER 170 - MAJOR REWARD</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter171strike" title="Link target outside of Sample">CHAPTER 171 - STRIKE</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter172negotiation" title="Link target outside of Sample">CHAPTER 172 - NEGOTIATION</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter173thestrugglebetweenthethreefactions" title="Link target outside of Sample">CHAPTER 173 - THE STRUGGLE BETWEEN THE THREE FACTIONS</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter174reconciliation" title="Link target outside of Sample">CHAPTER 174 - RECONCILIATION</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter175traveller" title="Link target outside of Sample">CHAPTER 175 - TRAVELLER</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter176recruitment" title="Link target outside of Sample">CHAPTER 176 - RECRUITMENT</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter177openspring" title="Link target outside of Sample">CHAPTER 177 - OPEN SPRING</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter178acquisitionofmysticalmaterials" title="Link target outside of Sample">CHAPTER 178 - ACQUISITION OF MYSTICAL MATERIALS</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter179negotiation" title="Link target outside of Sample">CHAPTER 179 - NEGOTIATION</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter180theblacktigergangsplan" title="Link target outside of Sample">CHAPTER 180 - THE BLACK TIGER GANG'S PLAN</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter181northernsuburbinsectnest" title="Link target outside of Sample">CHAPTER 181 - NORTHERN SUBURB INSECT NEST</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter182accident" title="Link target outside of Sample">CHAPTER 182 - ACCIDENT</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter183wormnest" title="Link target outside of Sample">CHAPTER 183 - WORMNEST</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter184seekermountain" title="Link target outside of Sample">CHAPTER 184 - SEEKER MOUNTAIN</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter185jadedragonancestor" title="Link target outside of Sample">CHAPTER 185 - JADE DRAGON ANCESTOR</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter186escapefromdeath" title="Link target outside of Sample">CHAPTER 186 - ESCAPE FROM DEATH</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter187cleaning" title="Link target outside of Sample">CHAPTER 187 - CLEANING</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter188cryoliteore" title="Link target outside of Sample">CHAPTER 188 - CRYOLITE ORE</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter189thewreckageofastarship" title="Link target outside of Sample">CHAPTER 189 - THE WRECKAGE OF A STARSHIP</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter190snowrace" title="Link target outside of Sample">CHAPTER 190 - SNOW RACE</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter191silverwolfmount" title="Link target outside of Sample">CHAPTER 191 - SILVER WOLF MOUNT</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter192newsfromthestonemountain" title="Link target outside of Sample">CHAPTER 192 - NEWS FROM THE STONE MOUNTAIN</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter193hornlessalien" title="Link target outside of Sample">CHAPTER 193 - HORNLESS ALIEN</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter194reminiscence" title="Link target outside of Sample">CHAPTER 194 - REMINISCENCE</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter195difficult" title="Link target outside of Sample">CHAPTER 195 - DIFFICULT</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter196chaoyangcity" title="Link target outside of Sample">CHAPTER 196 - CHAOYANG CITY</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter197angrylidene" title="Link target outside of Sample">CHAPTER 197 - ANGRYLIDENE</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter198sunstar" title="Link target outside of Sample">CHAPTER 198 - SUN STAR</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter199drinkspityou" title="Link target outside of Sample">CHAPTER 199 - DRINK SPIT YOU</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter200challenge" title="Link target outside of Sample">CHAPTER 200 - CHALLENGE</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?34546e17